module.exports = __webpack_public_path__ + "static/SFMono-RegularItalic-502441ff6ee56a1df1558e8461050a46.woff";